import Cookie from 'js-cookie'

import * as h2Api from '../h2Api'

export const RETRIEVE_CRM_FORM = 'RETRIEVE_CRM_FORM'
export const FORM_SUBMIT = 'FORM_SUBMIT'

export const getForm = formId => dispatch => {
  return dispatch(h2Api.get(`/api/v1/crm/form/${formId}`)({ type: RETRIEVE_CRM_FORM }))
}

export const submitHubspotForm = (formId, f) => dispatch => {
  //test account: "f68f38a6-a8ce-417b-bd5a-216d28c891e6"
  console.log(f)
  const hutk = Cookie.get('hubspotutk')

  console.log(hutk)
  const data = {
    hutk,
    fields: Object.keys(f).map(k => {
      return {
        name: k,
        value: f[k]
      }
    })
  }

  console.log(data)

  return dispatch(h2Api.post(`/api/v1/crm/submit/${formId}`, data)({ type: FORM_SUBMIT }))
}
